interface ITargetSegment {
    id: number;
    name: string;
}

interface IGoal {
    id: number;
    name: string;
    type: string;
}

interface IAssociatedVariation {
    id: number;
    name: string;
    instantiatedTemplate: any;
}

interface IVariation {
    id: number;
    name: string;
    instantiatedTemplate: any;
}

interface ITrafficDeviation {
    [key: string]: number;
}

export interface IApiAction {
    dateLaunched: number;
    dateModified: number;
    id: number;
    name: string;
    targetSegment: ITargetSegment;
    active: boolean;
    triggered: boolean;
    goals: IGoal[];
    untrackedTrafficReallocationTime: any;
    triggeredInVisit: boolean;
    mainGoal: IGoal;
    associatedVariation: IAssociatedVariation;
    trafficDeviation: ITrafficDeviation;
    variations: IVariation[];
    redirectProcessed: boolean;
    activatedInVisit: boolean;
}


export interface IExperiment {
    id: number,
	name: string
	cookieName: string
    activeVariantId: number,
    inactiveVariantId: number
    goalId: number
    defaultCookieValue: "active" | "inactive"
}

// Cookie names
export const wiypCookie = "wiyp2024"
export const galleryCookie = "gallery2024"


// Experiments
export const ABTestExperiments: IExperiment[] = [
    {
        id: 254723,
        name: "WIYP",
        cookieName: wiypCookie,
        activeVariantId: 988013,
        inactiveVariantId: 988015,
        goalId: 329833, 
        defaultCookieValue: 'inactive',
    },
]

